import { render, staticRenderFns } from "./MyCompanyMenu.vue?vue&type=template&id=6ffe38c6&scoped=true&"
import script from "./MyCompanyMenu.vue?vue&type=script&lang=js&"
export * from "./MyCompanyMenu.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyMenu.vue?vue&type=style&index=0&id=6ffe38c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffe38c6",
  null
  
)

export default component.exports